/**
 * Export the beyond translate service
 */
export { BydTranslateService } from './byd-translate.service';
